module.exports = __webpack_public_path__ + "trademark6.png?cf8d3e8d4062cff0e5dba9bf2541e7c2";


//////////////////
// WEBPACK FOOTER
// ./static/assets/trademark6.png
// module id = 506
// module chunks = 0